import {AxiosRequestHeaders, AxiosResponseHeaders} from 'axios';
import httpContext from 'express-http-context';
import {convertIterableToMap} from '../src/common/convertIterableToMap';
import {getEnv} from '../src/common/env/env';
import {ServerEnv} from '../src/common/env/ServerEnv.enum';
import {requestContext} from '../src/common/requestContext';

/**
 * Raw 한 API 요청/응답을 디버깅용으로 기록하기 위한 용도의 컨택스트입니다.
 */
export class ApiDebuggingContext {
  constructor() {}

  public putIfDebugging({
    request,
    response,
  }: {
    request?: {
      url: string;
      headers?: Headers | AxiosRequestHeaders;
      method: string;
      body: any;
    };
    response?: {
      url: string;
      headers: Headers | AxiosResponseHeaders;
      status: number;
      body: Record<string, any>;
    };
  }) {
    if (!this.isDebugging()) {
      return;
    }

    const apiHistoryObj = this.apiHistoryObj;
    if (request) {
      if (!apiHistoryObj[request.url]) {
        apiHistoryObj[request.url] = {};
      }
      apiHistoryObj[request.url].request = {
        headers: request.headers
          ? convertIterableToMap(request.headers)
          : undefined,
        method: request.method,
        body:
          request.body !== undefined && request.body !== null
            ? typeof request.body === 'string'
              ? request.body
              : (request.body as any).toString
                ? request.body.toString()
                : (request.body as any).toJSON
                  ? request.body.toJSON()
                  : undefined
            : undefined,
        url: request.url,
      };
    }

    if (response) {
      if (!apiHistoryObj[response.url]) {
        apiHistoryObj[response.url] = {};
      }
      apiHistoryObj[response.url].response = {
        ...response,
        ...{
          status: response.status,
          headers: convertIterableToMap(response.headers),
        },
      };
    }

    this.apiHistoryObj = apiHistoryObj;
  }

  isDebugging = () => {
    return (
      getEnv().envName !== ServerEnv.Real ||
      requestContext?.requestInfo?.logging
    );
  };

  get apiHistoryObj(): ApiHistoryObj {
    return process?.env?.JEST_WORKER_ID === undefined
      ? httpContext.get(CONTEXT_API_DEBUGGING_HISTORY_KEY) || {}
      : {};
  }

  set apiHistoryObj(apiHistoryObj: ApiHistoryObj) {
    process?.env?.JEST_WORKER_ID === undefined &&
      httpContext.set(CONTEXT_API_DEBUGGING_HISTORY_KEY, apiHistoryObj);
  }
}

interface ApiHistoryObj {
  [key: string]: {
    request?: Record<string, any>;
    response?: Record<string, any>;
  };
}

const CONTEXT_API_DEBUGGING_HISTORY_KEY = 'api-debugging-history-key';

/**
 * API 요청/응답 컨텍스트를 핸들링하는 싱글턴 인스턴스
 */
export const apiDebuggingContext = new ApiDebuggingContext();
